// PrazoConfig.js - ConfiguraÃ§Ãµes centrais do sistema de prazos jurÃ­dicos
export const PRAZO_CONFIG = {
  // Tipos de contagem de prazo
  TIPOS_CONTAGEM: {
    CORRIDO: 'corrido',
    DIAS_UTEIS: 'dias_uteis', 
    DIAS_UTEIS_JURIDICOS: 'dias_uteis_juridicos'
  },

  // Modalidades de prazo
  MODALIDADES: {
    SIMPLES: 'simples',
    DOBRO: 'dobro'
  },

  // HorÃ¡rios do expediente forense
  EXPEDIENTE: {
    INICIO: '08:00',
    FIM: '18:00'
  },

  // ConfiguraÃ§Ãµes de suspensÃ£o
  SUSPENSOES_AUTOMATICAS: {
    RECESSO_DEZEMBRO: {
      enabled: true,
      inicio: { dia: 20, mes: 12 },
      fim: { dia: 6, mes: 1 }
    },
    RECESSO_JULHO: {
      enabled: true,
      inicio: { dia: 1, mes: 7 },
      fim: { dia: 31, mes: 7 }
    }
  },

  // Feriados nacionais fixos
  FERIADOS_NACIONAIS_FIXOS: [
    { dia: 1, mes: 1, nome: 'ConfraternizaÃ§Ã£o Universal' },
    { dia: 21, mes: 4, nome: 'Tiradentes' },
    { dia: 1, mes: 5, nome: 'Dia do Trabalhador' },
    { dia: 7, mes: 9, nome: 'IndependÃªncia do Brasil' },
    { dia: 12, mes: 10, nome: 'Nossa Senhora Aparecida' },
    { dia: 2, mes: 11, nome: 'Finados' },
    { dia: 15, mes: 11, nome: 'ProclamaÃ§Ã£o da RepÃºblica' },
    { dia: 25, mes: 12, nome: 'Natal' }
  ],

  // Tipos de feriado
  TIPOS_FERIADO: {
    NACIONAL: 'nacional',
    ESTADUAL: 'estadual',
    MUNICIPAL: 'municipal',
    FACULTATIVO: 'facultativo'
  },

  // Regras jurÃ­dicas
  REGRAS: {
    INICIO_PRAZO_DIA_SEGUINTE: true,
    PRORROGACAO_DIA_NAO_UTIL: true,
    FIM_PRAZO_FINAL_EXPEDIENTE: true,
    CONSIDERAR_SABADO_UTIL: false,
    CONSIDERAR_DOMINGO_UTIL: false
  }
};

// FunÃ§Ã£o para calcular feriados mÃ³veis baseados na PÃ¡scoa
export const calcularFeriadosMoveis = (ano) => {
  // Algoritmo para calcular a PÃ¡scoa
  const calcularPascoa = (ano) => {
    const a = ano % 19;
    const b = Math.floor(ano / 100);
    const c = ano % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const mes = Math.floor((h + l - 7 * m + 114) / 31);
    const dia = ((h + l - 7 * m + 114) % 31) + 1;

    return new Date(ano, mes - 1, dia);
  };

  const pascoa = calcularPascoa(ano);
  const feriadosMoveis = [];

  // Carnaval (47 dias antes da PÃ¡scoa)
  const carnaval = new Date(pascoa);
  carnaval.setDate(carnaval.getDate() - 47);
  feriadosMoveis.push({
    data: carnaval,
    nome: 'Carnaval',
    tipo: PRAZO_CONFIG.TIPOS_FERIADO.NACIONAL
  });

  // Sexta-feira Santa (2 dias antes da PÃ¡scoa)
  const sextaFeira = new Date(pascoa);
  sextaFeira.setDate(sextaFeira.getDate() - 2);
  feriadosMoveis.push({
    data: sextaFeira,
    nome: 'Sexta-feira Santa',
    tipo: PRAZO_CONFIG.TIPOS_FERIADO.NACIONAL
  });

  // Corpus Christi (60 dias apÃ³s a PÃ¡scoa)
  const corpusChristi = new Date(pascoa);
  corpusChristi.setDate(corpusChristi.getDate() + 60);
  feriadosMoveis.push({
    data: corpusChristi,
    nome: 'Corpus Christi',
    tipo: PRAZO_CONFIG.TIPOS_FERIADO.NACIONAL
  });

  return feriadosMoveis;
};

// UtilitÃ¡rios de validaÃ§Ã£o
export const VALIDACOES = {
  isDataValida: (data) => {
    return data instanceof Date && !isNaN(data.getTime());
  },

  isPrazoPositivo: (prazo) => {
    return Number.isInteger(prazo) && prazo > 0;
  },

  isTipoContagemValido: (tipo) => {
    return Object.values(PRAZO_CONFIG.TIPOS_CONTAGEM).includes(tipo);
  },

  isModalidadeValida: (modalidade) => {
    return Object.values(PRAZO_CONFIG.MODALIDADES).includes(modalidade);
  }
};

export default PRAZO_CONFIG;
